const products = [
  {
    name: "FELIN VPN",
    tagline: "Invisible. Unstoppable. Secure.",
    description:
      "Enterprise-grade virtual private network for iOS. Route your traffic through encrypted tunnels across 90+ global servers, keeping your identity and data completely private.",
    badge: "Most Popular",
    badgeColor: "bg-emerald-100 text-emerald-700",
    accentColor: "bg-emerald-50",
    iconBg: "bg-emerald-500",
    icon: "ri-shield-keyhole-line",
    image:
      "https://public.readdy.ai/ai/img_res/ddade0aeb706bd6887ab9c6113a7e867.jpg",
    features: ["256-bit AES Encryption", "90+ Server Locations", "No-Log Policy", "Kill Switch"],
  },
  {
    name: "FELIN Cleaner",
    tagline: "Speed. Space. Simplicity.",
    description:
      "A powerful iOS cleaning and optimization utility that removes junk files, duplicate photos, and unnecessary cached data — restoring your iPhone to peak performance.",
    badge: "Editor's Choice",
    badgeColor: "bg-rose-100 text-rose-700",
    accentColor: "bg-rose-50",
    iconBg: "bg-rose-500",
    icon: "ri-delete-bin-6-line",
    image:
      "https://readdy.ai/api/search-image?query=sleek%20modern%20iOS%20phone%20cleaner%20app%20interface%20on%20iPhone%20mockup%20showing%20storage%20optimization%20clean%20minimalist%20UI%20with%20progress%20circles%20coral%20pink%20accent%20on%20white%20background%20professional%20product%20photography&width=400&height=500&seq=felin-cleaner-product&orientation=portrait",
    features: ["Smart Junk Removal", "Duplicate Photo Finder", "Cache Cleaner", "Storage Analyzer"],
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16 md:mb-20">
          <span className="text-xs font-semibold tracking-widest uppercase text-gray-400">Our Products</span>
          <h2 className="mt-3 text-4xl md:text-6xl font-bold text-gray-900 leading-tight">
            Built for iOS.<br />
            <span className="text-gray-400 font-light">Designed for you.</span>
          </h2>
          <p className="mt-5 text-gray-500 text-base md:text-lg max-w-xl leading-relaxed">
            Every product we ship goes through rigorous testing to ensure it meets the highest standards
            of performance, privacy, and usability on Apple devices.
          </p>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.name}
              className={`${product.accentColor} rounded-3xl overflow-hidden flex flex-col md:flex-row gap-0`}
            >
              {/* Image */}
              <div className="md:w-48 lg:w-56 flex-shrink-0 flex items-end justify-center pt-8 px-8 md:px-0 md:pl-8">
                <div className="w-40 md:w-full h-56 md:h-64 overflow-hidden rounded-2xl shadow-lg">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Info */}
              <div className="flex-1 p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-xl ${product.iconBg}`}>
                    <i className={`${product.icon} text-white text-base`} />
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${product.badgeColor}`}>
                    {product.badge}
                  </span>
                </div>

                <h3 className="text-2xl font-bold text-gray-900">{product.name}</h3>
                <p className="text-sm font-medium text-gray-500 mt-1 mb-3">{product.tagline}</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">{product.description}</p>

                <ul className="space-y-2">
                  {product.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-sm text-gray-700">
                      <span className="w-4 h-4 flex items-center justify-center text-emerald-500">
                        <i className="ri-checkbox-circle-fill text-base" />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom promo strip */}
        <div className="mt-14 bg-gray-900 rounded-3xl px-8 md:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-white font-bold text-xl">Available exclusively on iOS</p>
            <p className="text-gray-400 text-sm mt-1">
              Crafted for iPhone and iPad — fully native, fully optimized.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full">
              <i className="ri-apple-line text-white text-xl" />
            </div>
            <div>
              <p className="text-white text-xs font-medium">iOS 15 and above</p>
              <p className="text-gray-400 text-xs">iPhone &amp; iPad supported</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
